export const isFunction = (target: unknown): target is Function =>
  Object.prototype.toString.call(target).slice(8, -1) === "Function";


export const isArray = <T>(target: unknown): target is Array<T> =>
  Object.prototype.toString.call(target).slice(8, -1) === "Array";